<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_4"></a>CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/02_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/03_Chapter01">The First Year</a></h2>
<h2 class="toc"><span href="#/xhtml/04_Chapter02" title="Link target outside of Sample">Fear</span></h2>
<h2 class="toc"><span href="#/xhtml/05_Chapter03" title="Link target outside of Sample">Play and Fancy</span></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter04" title="Link target outside of Sample">Constructiveness</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter05" title="Link target outside of Sample">Selfishness and Property</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter06" title="Link target outside of Sample">Truthfulness</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter07" title="Link target outside of Sample">Punishment</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter08" title="Link target outside of Sample">Importance of Other Children</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter09" title="Link target outside of Sample">Affection and Sympathy</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter10" title="Link target outside of Sample">Sex Education</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter11" title="Link target outside of Sample">The Nursery School</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?2646d3b5